import { Button, Checkbox, InputNumber, Tooltip } from 'antd';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from '../../../common/SettingsContentPanel';
import { Flex } from '../../../common/Flex';
import './FlightSettings.less';
import ConditionalRender from 'app/common/components/ConditionalRender';
import { CfmuFlightType } from 'app/model/CORE';
import { CheckOutlined, ClearOutlined } from '@ant-design/icons';
import Utils from 'app/common/util/Utils';
import { Flights } from 'app/components/dashboard/detailed/flights/Flights';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export const DEFAULT_CFMU_TYPES = Object.keys(CfmuFlightType).map(k => k as CfmuFlightType);

export const DEFAULT_FLIGHT_LIST_FILTER_SETTINGS: FlightListFilterSettings = {
    textFilter: '',
    delayedOnly: false,
    delayThreshold: 0,
    selectedOnly: false,
    cfmuTypes: DEFAULT_CFMU_TYPES,
};

export interface FlightListFilterSettings extends FlightsSettings {
    textFilter: string;
}

export interface FlightsSettings {
    selectedOnly: boolean;
    delayedOnly: boolean;
    delayThreshold: number;
    cfmuTypes: CfmuFlightType[];
}

export class FlightsSettingsTitle extends PureComponent {
    render() {
        return (
            <Flex direction="vertical">
                <div className="flight-settings-title">FLIGHTS SETTINGS</div>
            </Flex>
        );
    }
}

export class FlightsSettingsContent extends SettingsContentPanel<FlightsSettings> {
    render() {
        return (
            <Flex direction="vertical" className="flight-settings-panel">
                <Flex direction="vertical" className="content">
                    <Flex>
                        <Checkbox
                            checked={this.state.selectedOnly}
                            onChange={value => this.setState({ selectedOnly: value.target.checked })}>
                            Selected flights only
                        </Checkbox>
                    </Flex>
                    <Flex>
                        <Checkbox
                            checked={this.state.delayedOnly}
                            onChange={value => this.setState({ delayedOnly: value.target.checked })}>
                            Delayed flights only
                        </Checkbox>
                    </Flex>
                    <ConditionalRender condition={this.state.delayedOnly}>
                        <Flex className="delay-threshold">
                            <div>At least</div>
                            <InputNumber
                                value={this.state.delayThreshold}
                                onChange={value => this.setState({ delayThreshold: value })}
                                min={0}
                            />
                            <div>mn</div>
                        </Flex>
                    </ConditionalRender>
                    <Flex direction={'vertical'} style={{ gap: '0.5em' }}>
                        <Flex style={{ gap: '1em' }}>
                            <div>States:</div>
                            <Tooltip
                                title="Select all"
                                overlayInnerStyle={{ minHeight: '0' }}
                                overlayStyle={{ paddingBottom: '0' }}
                                showArrow={false}>
                                <CheckOutlined
                                    style={{
                                        visibility:
                                            this.state.cfmuTypes.length == Flights.CFMU_FLIGHT_TYPES.length
                                                ? 'hidden'
                                                : 'visible',
                                    }}
                                    onClick={() => this.setState({ cfmuTypes: Flights.CFMU_FLIGHT_TYPES })}
                                />
                            </Tooltip>
                            <Tooltip
                                title="Clear all"
                                overlayInnerStyle={{ minHeight: '0' }}
                                overlayStyle={{ paddingBottom: '0' }}
                                showArrow={false}>
                                <ClearOutlined
                                    style={{ visibility: Utils.isEmpty(this.state.cfmuTypes) ? 'hidden' : 'visible' }}
                                    onClick={() => this.setState({ cfmuTypes: [] })}
                                />
                            </Tooltip>
                        </Flex>
                        <Flex
                            direction="vertical"
                            style={{
                                gap: '0.5em',
                                border: '0.05em solid #8C8B82',
                                borderRadius: '0.5em',
                                marginLeft: '0.5em',
                                padding: '0.5em 0',
                            }}>
                            {this.renderStates()}
                        </Flex>
                    </Flex>
                </Flex>
                <Flex className="buttons">
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }

    private renderStates = () => {
        return Flights.CFMU_FLIGHT_TYPES.map(type => {
            return (
                <Checkbox
                    style={{ marginLeft: '1em' }}
                    key={type}
                    checked={this.state.cfmuTypes.includes(type)}
                    onChange={e => this.onTypeCheck(e, type)}>
                    {type}
                </Checkbox>
            );
        });
    };

    private onTypeCheck = (event: CheckboxChangeEvent, type: CfmuFlightType) => {
        if (event.target.checked) {
            this.setState({ cfmuTypes: [...this.state.cfmuTypes, type] });
        } else {
            this.setState({ cfmuTypes: this.state.cfmuTypes.filter(r => r !== type) });
        }
    };
}
